<template>
  <div>
    <v-container>
      <h1>Employee Clearance Entry</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
          <v-btn icon text :to="`/emp-clearance-summary`">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="Date"
            v-model="model.date"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            :class="classPadding"
            label="EmpCode"
            :value="model.empCode"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Name"
            :value="model.fullName"
            :class="classPadding"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Department"
            :class="classPadding"
            :value="model.depDesc"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Designation"
            :class="classPadding"
            :value="model.desDesc"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Separation date"
            :class="classPadding"
            :value="model.dateOfSeparation"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            label="Reason"
            :items="reasons"
            item-text="text"
            item-value="value"
            :class="classPadding"
            v-model="model.reason"
            readonly
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Agreement Bond"
            :class="classPadding"
            :value="model.agreementBond"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="ATM Card"
            :class="classPadding"
            :value="model.atmCard"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="ID"
            :class="classPadding"
            :value="model.idNo"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="CAARCA"
            :class="classPadding"
            :value="model.caarca"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Uniform"
            :class="classPadding"
            :value="model.uniform"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Safety Shoes"
            :class="classPadding"
            :value="model.safetyShoes"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Tools"
            :class="classPadding"
            :value="model.tools"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-data-table
            :items="attachments"
            :headers="attachmentHeaders"
            v-if="attachments.length > 0"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn text outlined @click.prevent="openFile(item)">View</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-data-table
        :items="items"
        :headers="headers"
        v-if="items.length > 0"
      ></v-data-table>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-textarea
            v-model="remarks"
            :class="classPadding"
            label="Approver Remarks"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn color="success" @click.stop="preview" :loading="loading"
            >preview</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { isNullOrUndefined } from "../../../../validation/validation";
import moment from "moment";
import userAccessMixin from "../../../../mixins/userAccessMixin";
// const API_ENDPOINT_OAG = "/api/oApproverGroup";
const API_ENDPOINT = "/api/empClearance";
export default {
  metaInfo: {
    title: "Employee Clearance Entry",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    model: {
      reason: "VR"
    },
    reasons: [
      {
        text: "VOLUNTARY RESIGNATION",
        value: "VR"
      },
      {
        text: "RETIREMENT DUE TO AGE",
        value: "RA"
      },
      {
        text: "RETIREMENT DUE TO PHYSICAL DISABILITY",
        value: "RPD"
      },
      {
        text: "DEATH",
        value: "D"
      },
      {
        text: "TERMINATION FOR A CAUSE",
        value: "T"
      },
      {
        text: "OTHERS",
        value: "O"
      }
    ],
    groupCodes: [],
    selectedGroup: null,
    attachment: null,
    isUploading: false,
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Approver",
        value: "fullName",
        sortable: true
      },
      {
        text: "Code",
        value: "approverCode",
        sortable: true
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: true
      },
      {
        text: "Order",
        value: "approverOrder",
        sortable: true
      }
    ],
    loading: false,
    attachments: [],
    attachmentHeaders: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "File Name",
        value: "fileName",
        sortable: true
      },
      {
        text: "Created By",
        value: "createdBy",
        sortable: true
      }
    ],
    status: "PENDING",
    remarks: null,
    isCancelling: false
  }),
  methods: {
    // getByGroupCode() {
    //   var groupType = "EC";
    //   this.$axios
    //     .get(`${API_ENDPOINT_OAG}/${groupType}`)
    //     .then(({ data }) => {
    //       this.groupCodes = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     });
    // },
    // getMember(groupCode) {
    //   this.$axios
    //     .get(`${API_ENDPOINT_PR}/${groupCode}`)
    //     .then(({ data }) => {
    //       this.items = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     });
    // },
    upload() {
      let { ecfNo } = this.$route.params;
      this.isUploading = true;
      var formData = new FormData();
      formData.append("attachment", this.attachment);
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/upload-ecf?ecfNo=${ecfNo}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.attachment = null;
          this.getAttachment(ecfNo);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    getAttachment(ecfNo) {
      this.$axios
        .get(`${API_ENDPOINT}/attachment?ecfNo=${ecfNo}`)
        .then(({ data }) => {
          this.attachments = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    openFile(item) {
      var subPath = process.env.VUE_APP_PATH;
      // var newSubPath = "";
      // if (subPath.length > 1) {
      //   newSubPath = subPath.slice(0, -1);
      // } else {
      //   newSubPath = subPath.slice(0, -1);
      // }
      window.open(`${subPath.slice(0, -1)}${item.filePath}`);
    },
    reset() {
      this.getAttachment("");
      this.model = {
        reason: "VR"
      };
    },
    getDetails(ecfNo) {
      this.$axios
        .get(`${API_ENDPOINT}/approval/${ecfNo}`)
        .then(({ data }) => {
          if (!isNullOrUndefined(data.date)) {
            data.date = moment(data.date).format("MM/DD/YYYY");
          }
          if (!isNullOrUndefined(data.dateOfSeparation)) {
            data.dateOfSeparation = moment(data.dateOfSeparation).format(
              "MM/DD/YYYY"
            );
          }
          this.model = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    preview() {
      let { ecfNo } = this.$route.params;
      let routeData = this.$router.resolve({
        name: "report-viewer",
        query: { ecfNo: ecfNo, type: "ec-preview" }
      });
      window.open(routeData.href, "_blank");
    }
  },
  computed: {
    enableApproveButton() {
      let { status } = this.$route.query;

      if (isNullOrUndefined(status)) return false;

      if (
        status == "APPROVED" ||
        status == "DECLINED" ||
        status == "WAITING" ||
        status == "CANCEL"
      )
        return false;

      return true;
    }
  },
  created() {
    let { ecfNo } = this.$route.params;
    this.getAttachment(ecfNo);
    this.getDetails(ecfNo);

    this.getUserAccessRights("ECSUMMARY");
  },
  watch: {
    // selectedGroup(val) {
    //   this.getMember(val);
    // }
  }
};
</script>